// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultLayout_wrapper__bj48j","scroll-to-top":"DefaultLayout_scroll-to-top__8kiHE"};